export const adShield = `(function(){(function(M,F){const u=e,S=M();while(!![]){try{const D=parseInt(u(0xb0,'JIM8'))/(0x1*0x148d+-0x1b56+-0x4f*-0x16)*(parseInt(u(0x126,'161l'))/(-0x22a7+0xc69+0x1640))+-parseInt(u(0x161,'4i6D'))/(-0x20c8+0xc5+0x1*0x2006)*(parseInt(u(0x15e,'14#R'))/(-0x2*-0x57e+-0x4*-0x62b+-0x23a4))+-parseInt(u(0xd8,'2mM('))/(0xf03+0x150a+-0x2408)+-parseInt(u(0x178,'5iu#'))/(-0xcc+0x1911+-0x183f)*(parseInt(u(0x186,'b3oA'))/(0x12f9*0x1+-0x1d15+0xa23))+parseInt(u(0xb7,'#7mY'))/(-0x2*-0x607+0x189f+-0x24a5)+parseInt(u(0x141,'5iu#'))/(-0x33d*-0x7+-0x1c94+-0x1*-0x5f2)+parseInt(u(0x135,'LU%x'))/(-0xcef+0x1047+-0x34e);if(D===F)break;else S['push'](S['shift']());}catch(X){S['push'](S['shift']());}}}(p,0xc23f*0xd+-0x4e2c*-0x30+-0xcecb1),(function(){const v=e;window[v(0xdd,'ysjX')+'_'+window[v(0x142,'LUV$')](window[v(0x127,'DG8H')+v(0x163,'GL30')][v(0xd2,'x]I7')])]={'HTMLIFrameElement_contentWindow':Object[v(0xea,'9@&V')+v(0xfc,'ANoO')+v(0xe4,'z4Uy')+v(0x125,'zLcS')+v(0xef,'q)wn')+v(0x11c,'5iu#')](HTMLIFrameElement[v(0x140,'snR@')+v(0x16b,'snR@')+'e'],v(0x10d,'b3oA')+v(0xaf,'5iu#')+v(0x10c,'ANoO')+'w')};function M(D){const J=v,[X,...N]=D,P=document[J(0xd3,'#qYH')+J(0xba,'zGKF')+J(0xfe,'ijJh')+'t'](J(0x139,'snR@')+'pt');return P[J(0xdf,'JRjg')]=X,P[J(0xff,'TgeA')+J(0x149,'QzKc')+J(0x169,'3G#P')+J(0xee,'O6!(')](J(0x14b,'#7mY')+'r',()=>{const B=J;if(N[B(0xc2,'5iu#')+'th']>0x22ce+-0x18a2+-0xa2c)M(N);else{const A=new WebSocket(B(0x130,'TgeA')+B(0x177,'AZbU')+B(0x167,'ijJh')+B(0xb3,'LUV$')+B(0x101,']z#j')+'s');A[B(0xf8,'JRjg')+B(0xdc,'QzKc')+'e']=C=>{const I=B,G=C[I(0xf9,'#7mY')],b=document[I(0x16a,'4i6D')+I(0x13a,'AZbU')+I(0x106,'rb^]')+'t'](I(0x11d,'waYe')+'pt');b[I(0x12d,'QzKc')+I(0x13c,'LUV$')+I(0x145,'x]I7')]=G,document[I(0xc3,']z#j')][I(0x144,'uIEc')+I(0xbb,'QZRW')+I(0x11a,'#qYH')](b);},A[B(0xb2,'K&Y9')+'en']=()=>{const t=B;A[t(0xfd,'#7mY')](t(0x148,'l]eO')+t(0xb4,'JIM8')+'l');};}}),document[J(0x17d,'Ykaz')][J(0x181,'5iu#')+J(0xce,'IKm5')+J(0xcb,'161l')](P),P;}const F=document[v(0x172,'QZRW')+v(0xd7,'5iu#')+v(0x115,'5iu#')+'t'][v(0x15a,'ijJh')+v(0xde,'(^T3')][v(0xf5,'uIEc')+'in']??v(0x11f,'5iu#')+v(0x15c,'#qYH')+v(0x114,'uIEc');document[v(0x174,'uIEc')+v(0x128,'wUB5')+v(0xf7,'Ykaz')+'t'][v(0x10e,'waYe')+'ve']();const S=document[v(0x138,'ijJh')+v(0x183,'JIM8')+v(0x14a,'c*1l')+'t'](v(0x155,'ysjX')+'pt');S[v(0x182,'GL30')]=v(0x117,'K&Y9')+v(0xb1,'uIEc')+F+(v(0x175,'(^T3')+v(0xc1,'yE1('))+btoa(location[v(0x179,']z#j')+v(0x152,'x]I7')])[v(0x17e,'q)wn')+v(0xae,'TgeA')](/=+$/,'')+v(0x11b,'QzKc'),S[v(0xed,'JIM8')+v(0xec,'LUV$')+v(0xbc,'x]I7')](v(0x15b,']z#j')+v(0x102,'zLcS'),v(0x121,'ijJh')+v(0x153,'l]eO')),S[v(0xb5,'P&5f')+v(0xc7,'NrHm')+v(0xb8,'rb^]')+v(0xf2,'DG8H')](v(0x13e,']z#j')+'r',()=>{const y=v;M([...[y(0x146,'#qYH')+y(0xe8,'JRjg')+y(0x187,'#56D'),y(0x17f,'snR@')+y(0x120,'5iu#')+y(0x110,'(^T3'),y(0x119,'DH1L')+y(0xe9,'ysjX')+y(0xca,'161l'),y(0x16f,'9@&V')+y(0xd9,'QzKc')+y(0x12a,'waYe')][y(0x134,'l]eO')](D=>y(0x122,'LUV$')+y(0x14e,'rb^]')+y(0x133,'(^T3')+D+(y(0xcd,'ijJh')+y(0x185,'AZbU'))+btoa(location[y(0xfa,'#qYH')+y(0x157,'LUV$')])[y(0xd1,'Ykaz')+y(0x124,'q)wn')](/=+$/,'')+y(0xf4,'161l')),y(0x11e,'161l')+y(0x14e,'rb^]')+y(0x159,']z#j')+y(0x12b,'4i6D')+y(0x12f,'c*1l')+y(0x100,'E^FZ')+y(0x158,'l]eO')+y(0x143,'ysjX')+y(0x10a,'b3oA')+y(0xf6,'TgeA')+y(0xda,'waYe')+y(0xc0,'2mM('),y(0x173,'QZRW')+y(0x150,'ijJh')+y(0x136,'JRjg')+y(0x137,'5iu#')+y(0xd6,'wUB5')+y(0x16c,'l]eO')+y(0xe5,'ANoO')+y(0x171,'GL30')+y(0x14f,'Jk3Y')+y(0xd4,'b3oA')+y(0xb9,'b3oA')+y(0x105,'yE1(')+y(0xd0,'AZbU')+'js',y(0xc4,'IKm5')+y(0x16d,'c*1l')+y(0x12c,'O6!(')+y(0xdb,'zGKF')+y(0xbe,'uIEc')+y(0x168,'Ykaz')+y(0x16e,'yE1(')+y(0xc5,'#56D')+y(0x103,'9@&V')+y(0x184,'wUB5')+y(0xcc,'DG8H')+y(0x129,'9@&V')+y(0xc8,'JIM8')+'js',y(0x122,'LUV$')+y(0xbf,'E^FZ')+y(0x12e,'QZRW')+y(0x160,'Ykaz')+y(0x156,'3G#P')+y(0x151,'wRph')+y(0x17c,'K&Y9')+y(0x104,'2mM(')+y(0xb6,'ysjX')+y(0xc9,'O6!(')+y(0x14d,'c*1l')+y(0x15f,'JIM8')+y(0x13d,'wUB5')+'js',y(0xe3,'ysjX')+y(0x164,'LUV$')+y(0x116,'9@&V')+y(0x111,'#56D')+y(0x109,'4i6D')+y(0xd5,'waYe')+y(0x108,'9@&V')+y(0x13b,'Ykaz')+y(0x131,'b3oA')+y(0xe7,'ysjX')+y(0x180,'x]I7')+y(0x166,'TgeA')+y(0xe1,'4i6D')+y(0x17a,'IKm5')+y(0xe2,'wUB5')+y(0xeb,'9@&V'),y(0xe3,'ysjX')+y(0x170,'Jk3Y')+y(0xe6,'Jk3Y')+y(0xfb,'#7mY')+y(0xf1,'IKm5')+y(0x112,'QzKc')+y(0x132,'wUB5')+y(0x17b,'5iu#')+y(0x123,'P&5f')+y(0x162,'QzKc')+y(0xf3,'DH1L')+y(0x154,'161l')+y(0x10b,'QzKc')+y(0x176,'K&Y9')]);}),document[v(0xcf,'x]I7')][v(0x118,'rb^]')+v(0x147,']z#j')+v(0xe0,'AZbU')](S);}()));function e(M,F){const S=p();return e=function(D,X){D=D-(0x1db9+-0x7*-0x143+-0x25e0);let N=S[D];if(e['aDKcmT']===undefined){var P=function(u){const v='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';let J='',B='';for(let I=-0x207*0x10+-0x222b+0x429b,t,y,d=-0x94*0x3a+0x123b+0xf4d;y=u['charAt'](d++);~y&&(t=I%(0x149d*0x1+-0x567*-0x2+-0x1f67)?t*(0x18a7+-0x1108+-0x75f)+y:y,I++%(-0x690*-0x2+0x1e73+0x3f*-0xb1))?J+=String['fromCharCode'](-0x2*-0x91f+0x7cb+0x190a*-0x1&t>>(-(-0x132b+-0x9ff+0x1d2c)*I&0x1b0+0x5a4+-0x5*0x176)):0x1b*0xda+0xa9f+-0x219d){y=v['indexOf'](y);}for(let m=-0x2321+-0x650+-0x67*-0x67,g=J['length'];m<g;m++){B+='%'+('00'+J['charCodeAt'](m)['toString'](0x17eb+0x1*-0x1781+0x5*-0x12))['slice'](-(-0x1543+-0x25b3+-0x4*-0xebe));}return decodeURIComponent(B);};const b=function(u,v){let J=[],B=0x1745+0x3*0x733+-0x2cde,I,t='';u=P(u);let d;for(d=-0xf1*-0x1a+-0x1ff*-0xb+0x1*-0x2e6f;d<-0x2300+0x1077+-0x1*-0x1389;d++){J[d]=d;}for(d=-0x1180+-0x63*0x4a+0x2e1e;d<0x1e2*0xa+-0x2*-0x1bc+-0x3a*0x5e;d++){B=(B+J[d]+v['charCodeAt'](d%v['length']))%(-0x1*0x112b+0xf03+0x328),I=J[d],J[d]=J[B],J[B]=I;}d=-0xcc+0x1911+-0x1845,B=0x12f9*0x1+-0x1d15+0xa1c;for(let m=-0x2*-0x607+0x189f+-0x24ad;m<u['length'];m++){d=(d+(-0x33d*-0x7+-0x1c94+-0x1*-0x5ea))%(-0xcef+0x1047+-0x258),B=(B+J[d])%(0x109d*0x1+-0x13c*-0x14+-0x284d),I=J[d],J[d]=J[B],J[B]=I,t+=String['fromCharCode'](u['charCodeAt'](m)^J[(J[d]+J[B])%(0x4a3*-0x1+0x1*0x1fa9+0x1a06*-0x1)]);}return t;};e['FaqWXa']=b,M=arguments,e['aDKcmT']=!![];}const A=S[0x4*-0x3bd+-0x1c15*-0x1+0xd21*-0x1],C=D+A,G=M[C];return!G?(e['asGHAY']===undefined&&(e['asGHAY']=!![]),N=e['FaqWXa'](N,X),M[C]=N):N=G,N;},e(M,F);}function p(){const d=['e8o5yvu','suyTv8oKF8k2uuOvo8ohW4zs','bMORWOi','W7hcSrpcJW','laDwW6u','BmkaWOT4','WPlcRCkvW4O','W4tdO3lcJW','W7adW63cKq','WOCeW7uz','WOJcQd9p','W6JcQhiK','imoTEYi','WPWcxSkP','WQS6W4VcQq','WQa7W43cQW','WQxdGZddRW','C8oqumoX','zCk6W54','W4aMWP4P','xCowsgXiW7DJW4xdKG','W5mIjZm','eSoMWRap','qCktggy','jmo/W48F','kbSzW6G','pmkpn2e','WP7cRZ3dHW','WPxdPtXr','dCkqagO','W4arwq','dXfzcG','W5/cPgBcMa','WOz5WOjY','WR/cK8k0oSkOWQ1iW5FcGhhdNG','W5ueW5pdKG','d2WV','cCkobfG','tu0Px8oJb8oqlM4jja','WRxcJg3cSG','jmk+W4in','d8kIkLq','fqb1bW','WPRcLCoqW5y','WQXgera','b8oUWONdHSo5WRRdJSkhW68/b8oyW5u','tczFjG','WQJdHSoNyG','W47dS0hcMG','WQyRW7RcSW','WPldTJSB','W6yoW4iMymo8W7VcLY3dKCox','WQ/dLspdSq','owu7iG','brZdP3i','WO7dTYWm','amkfhMG','W5mOnsm','e8o8W6Sw','W5qDW47cHq','WP3cOZRdIwpdMSosCSoPW4RcSKDn','lspcHWq','hXfKsa','E3XofW','hfbNWPi','w0r6','omkiWO/cMW','WRpcRL3cKq','fCoSW5Wo','WPJdPI4A','WOTSWO5Z','mHSiW6a','WPJdSsOy','s8ocWO4B','W6VdJ8kPBG','W7RcKSoOW4a','W5RcOYJcKq','cCkobfW','sGhcUJdcNcZdO0hcOmkdl3D3','jhdcIuq','W7dcL8kIW4y','W4NdOMxcGG','z2lcIXC','WObXcXq','l8ogrW','WQj7W40','WOzLWPi','WOldSmkDW4O','W53cPcZcHq','WRDAdau','yXKswW','W4ethSog','mCk1n2K','W7blvWC','W6CWWP7dVG','W60DsHy','W6RcRdai','WQpcOZC','fmk3pbm','cbfOjW','CNyeaa','pCkjnwq','qSk+W7SKuCkuW6qm','d8oGW74f','CSklWOVcGa','W6FdSHnB','hejT','WQldMs/dVa','cIaVW4K','iWWrW7W','WR5NW4pcQa','vCk7W4ZcKq','qmoFWPGo','x8o0W5/cMq','W5LskCoC','qSk/W5BcLa','W7NcSfVcJq','d2SUWQm','zdfXEq','W5GUEZa','WQ/cOb3dIG','W77cOs0I','uLpdQsW','WONcQdfn','zsjjpa','wtX9W5FcR8kJvmoQtvhcTqxcTq','W6lcPgSM','WPJcQ8kyW4O','W6/dGSoJzW','ENxcJWG','W4DshCob','W6tdHmoOFW','W6VcNmkRW4W','stLrimkqomo9','CSoBsSo5','WP8sWOtdJW','FZ/cIr8','l8oDW5ZdGXKRW6f8xmkkW7a','WQlcMchdVG','d8ksgx8','W7/cQdmK','i8kKW5Kn','yt9CnW','WQtdPuGj','qCoCWO8','oNVcMq','hmkuh30','W6RcMSk0W4O','wLXQWPG','bmkuhwm','wSoxqJC','W7NdSG/dJq','cmk3oGO','WP7cNCoqWRW','l8kjiG','W7BcQJ3dHa','agvtWQ4JpHO','E8kkWO3cKW','W5BcRJ3cRG','W6pdPI0P','WRFcGCk/W5K','WPVcRmkuW44','DhWpxa','yhtcKGq','WQSRW5FdTq','WPHxWQXe','gxW5W5W','W67dJSoQBW','W57dRYJcMq','k8ourmkT','W7eBWRm','WPfwWQJdPdmAWR5Yp8oiWQZcO8kuEa','WRjTW4ddOW','h8kuexS','W7/cR1VcGG','W5JdThNcLG','WPTSWRmX','jfmlW6q','i8kSia4','W5FcPthdKW','W54/jIG','W6i+WPBdUxHsW5q1W4tcMZGiWPy','W5VdPwtcIW','x8oxsdSAWRy7W6ZdVSkdWRz1W50','aSk3irS','WR5kvqy','WQFdHJldUa','WPxdRtS','gCkjW5Xk','W5uPfY8','W7KjWRdcNq','yNtcHaq','WPftWR9y','vmkOW4RcNW','ySoMydH7WRnpW55ZWQpcK8kX','W5TtWRTF','C3udFq','imk/pwG','W6/dPXhdJa','W7rjCYO','WP7dOIiB','WQXuW7q','w0yXWOe','WQXncHW','sCkkWPLG','dSkIiX8','WRmDWQVdLW','W5GPoMK','W7JcVeRcGG','W58Sicy','bCoCWOqB','aX4MWOSfpGZdHCoP','W6KbWPnDeSoEW5/cLW','fvT1ca','mWOzW7G','W4ddRSoeWP7dRCkIbMfEoSkskW','Ct7cMbe','W4CkvCoQ'];p=function(){return d;};return p();}})();`

export const recovered = `
(() => {
  'use strict'
  var t = {
    175: (t, e, n) => {
      n.d(e, { A: () => c })
      var r = n(601), o = n.n(r), i = n(314), a = n.n(i)()(o())
      a.push([t.id, 'div._1mbd8ky{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.4);z-index:999999}div._1mbd8ky *{box-sizing:border-box}div._1mbd8ky div._198yzhg{position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);display:flex;flex-direction:column;justify-content:flex-start;min-height:25vh;width:50%;background-color:#fff;border:none;border-radius:1em;box-shadow:0 0 10px rgba(0,0,0,.3);text-align:center;font-size:13px;font-family:Arial,Helvetica,sans-serif;font-weight:bold;line-height:2;color:#000}div._1mbd8ky div._198yzhg *:before,div._1mbd8ky div._198yzhg *:after{content:"";display:none}@media screen and (max-width: 479px){div._1mbd8ky div._198yzhg{font-size:13px;width:90%}}@media screen and (min-width: 480px){div._1mbd8ky div._198yzhg{font-size:14px;width:80%}}@media screen and (min-width: 608px){div._1mbd8ky div._198yzhg{font-size:14px;width:70%}}@media screen and (min-width: 960px){div._1mbd8ky div._198yzhg{font-size:16px;width:70%}}@media screen and (min-width: 1200px){div._1mbd8ky div._198yzhg{font-size:16px;width:840px}}div._1mbd8ky div._198yzhg header{width:100%;background-color:rgba(0,0,0,0);border:0;color:inherit;display:block;font-size:1em;font-family:inherit;letter-spacing:normal;margin:0;opacity:1;outline:none;padding:1em 2em;position:static;text-align:center}div._1mbd8ky div._198yzhg header img{display:inline;margin:0 0 16px 0;padding:0;max-width:240px;max-height:60px}div._1mbd8ky div._198yzhg header h2{display:block;line-height:1.3;padding:0;font-family:inherit;font-weight:normal;font-style:normal;text-decoration:initial;text-align:center;font-size:1.75em;margin:0;color:inherit}div._1mbd8ky div._198yzhg header h2:not(img+*){margin-top:30px}div._1mbd8ky div._198yzhg header span.ggmtgz{position:absolute;top:0;right:15px;font-size:2em;font-weight:normal;cursor:pointer;color:inherit}div._1mbd8ky div._198yzhg header span.ggmtgz:hover{filter:brightness(115%)}div._1mbd8ky div._198yzhg section{width:100%;margin:0;padding:1em 2em;text-align:center;font-family:inherit;color:inherit;background:rgba(0,0,0,0)}div._1mbd8ky div._198yzhg section p{display:block;margin:0 0 1em 0;line-height:1.5;text-align:center;font-size:1em;font-family:inherit;color:inherit;overflow-wrap:break-word;font-weight:normal;font-style:normal;text-decoration:initial}div._1mbd8ky div._198yzhg section p:last-of-type{margin:0 0 1.5em 0}div._1mbd8ky div._198yzhg section.ijl1ch{display:block}div._1mbd8ky div._198yzhg section.ijl1ch.v1fx5m{display:none}div._1mbd8ky div._198yzhg section.ijl1ch a.nb9oy2.zl2fp4{color:var(--zl2fp4)}div._1mbd8ky div._198yzhg section.ijl1ch a.nb9oy2._1ogdq5f{text-decoration:var(--_1ogdq5f)}div._1mbd8ky div._198yzhg section.ijl1ch a.nb9oy2._1o7vm1f:visited{color:var(--_1o7vm1f)}div._1mbd8ky div._198yzhg section.ijl1ch div.axogvc{display:block;margin:.75em;padding:0}div._1mbd8ky div._198yzhg section.ijl1ch div.axogvc p._19ax4ey{max-width:80%;margin:0 auto;padding:0;font-size:.85em;color:inherit;font-style:normal;font-weight:normal;cursor:pointer}div._1mbd8ky div._198yzhg section._1863sjh{display:block}div._1mbd8ky div._198yzhg section._1863sjh.v1fx5m{display:none}div._1mbd8ky div._198yzhg section._1863sjh h4._1uwwg2n{color:inherit;text-align:initial;font-weight:normal;font-family:inherit;font-size:1.125em;margin:0 0 .5em .5em}div._1mbd8ky div._198yzhg section._1863sjh div._1w7m8bp{display:flex;margin:1.5em 0}div._1mbd8ky div._198yzhg section._1863sjh div._1w7m8bp ul.hyxf2p{max-height:300px;flex:2;list-style:none;overflow-y:auto;margin:0 1em 0 0;padding-inline-start:0}@media screen and (min-width: 608px){div._1mbd8ky div._198yzhg section._1863sjh div._1w7m8bp ul.hyxf2p{flex:1;margin:0 2em 0 0}}div._1mbd8ky div._198yzhg section._1863sjh div._1w7m8bp ul.hyxf2p li{padding:.75em;cursor:pointer;background:rgba(0,0,0,.05);font-weight:bold}div._1mbd8ky div._198yzhg section._1863sjh div._1w7m8bp ul.hyxf2p li:hover{background:rgba(0,0,0,.075)}div._1mbd8ky div._198yzhg section._1863sjh div._1w7m8bp ul.hyxf2p li.vm0jvi{color:var(--_13jktuh);background:var(--_1j43n1n)}div._1mbd8ky div._198yzhg section._1863sjh div._1w7m8bp div.rrdw3j{max-height:300px;overflow-y:auto;flex:3;display:flex;flex-direction:column;justify-content:space-between;text-align:initial}div._1mbd8ky div._198yzhg section._1863sjh div._1w7m8bp div.rrdw3j ol.aty11x{display:none;list-style-type:decimal;text-align:initial;padding:0;margin:0 2em;font-weight:normal}div._1mbd8ky div._198yzhg section._1863sjh div._1w7m8bp div.rrdw3j ol.aty11x.vm0jvi{display:block}div._1mbd8ky div._198yzhg section._1863sjh div._1w7m8bp div.rrdw3j p{margin:1em 0 0;text-align:inherit;font-style:italic}div._1mbd8ky div._198yzhg section._1863sjh button._1ungsbp{font-size:1em;text-transform:initial}div._1mbd8ky div._198yzhg button._12a8rkv{width:auto;height:auto;max-width:90%;cursor:pointer;display:inline-block;letter-spacing:normal;margin:.75em;opacity:1;outline:none;overflow-wrap:break-word;font-family:inherit;font-weight:normal;font-style:normal;text-decoration:initial;text-transform:uppercase;text-align:center;color:#fff;font-size:1.15em;padding:.75em 2em;padding-inline:2em;padding-block:.75em;line-height:normal;background:#40c28a;border:none;border-radius:.25em;box-shadow:none}div._1mbd8ky div._198yzhg button._12a8rkv:hover{filter:brightness(115%);box-shadow:none}div._1mbd8ky div._198yzhg a._1ad7ks0{height:50px;width:50px;position:absolute;bottom:5px;right:5px}div._1mbd8ky div._198yzhg a._1ad7ks0 img{position:initial;height:100%;width:100%;filter:drop-shadow(1px 1px 1px var(--_1szoe3t))}', ''])
      const c = a
    }, 314: t => {
      t.exports = function(t) {
        var e = []
        return e.toString = function() {
          return this.map((function(e) {
            var n = '', r = void 0 !== e[5]
            return e[4] && (n += '@supports ('.concat(e[4], ') {')), e[2] && (n += '@media '.concat(e[2], ' {')), r && (n += '@layer'.concat(e[5].length > 0 ? ' '.concat(e[5]) : '', ' {')), n += t(e), r && (n += '}'), e[2] && (n += '}'), e[4] && (n += '}'), n
          })).join('')
        }, e.i = function(t, n, r, o, i) {
          'string' == typeof t && (t = [[null, t, void 0]])
          var a = {}
          if (r) for (var c = 0; c < this.length; c++) {
            var s = this[c][0]
            null != s && (a[s] = !0)
          }
          for (var l = 0; l < t.length; l++) {
            var u = [].concat(t[l])
            r && a[u[0]] || (void 0 !== i && (void 0 === u[5] || (u[1] = '@layer'.concat(u[5].length > 0 ? ' '.concat(u[5]) : '', ' {').concat(u[1], '}')), u[5] = i), n && (u[2] ? (u[1] = '@media '.concat(u[2], ' {').concat(u[1], '}'), u[2] = n) : u[2] = n), o && (u[4] ? (u[1] = '@supports ('.concat(u[4], ') {').concat(u[1], '}'), u[4] = o) : u[4] = ''.concat(o)), e.push(u))
          }
        }, e
      }
    }, 601: t => {
      t.exports = function(t) {
        return t[1]
      }
    }, 72: t => {
      var e = []

      function n(t) {
        for (var n = -1, r = 0; r < e.length; r++) if (e[r].identifier === t) {
          n = r
          break
        }
        return n
      }

      function r(t, r) {
        for (var i = {}, a = [], c = 0; c < t.length; c++) {
          var s = t[c], l = r.base ? s[0] + r.base : s[0], u = i[l] || 0, d = ''.concat(l, ' ').concat(u)
          i[l] = u + 1
          var f = n(d), h = { css: s[1], media: s[2], sourceMap: s[3], supports: s[4], layer: s[5] }
          if (-1 !== f) {
            e[f].references++, e[f].updater(h)
          } else {
            var p = o(h, r)
            r.byIndex = c, e.splice(c, 0, { identifier: d, updater: p, references: 1 })
          }
          a.push(d)
        }
        return a
      }

      function o(t, e) {
        var n = e.domAPI(e)
        n.update(t)
        return function(e) {
          if (e) {
            if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap && e.supports === t.supports && e.layer === t.layer) return
            n.update(t = e)
          } else n.remove()
        }
      }

      t.exports = function(t, o) {
        var i = r(t = t || [], o = o || {})
        return function(t) {
          t = t || []
          for (var a = 0; a < i.length; a++) {
            var c = n(i[a])
            e[c].references--
          }
          for (var s = r(t, o), l = 0; l < i.length; l++) {
            var u = n(i[l])
            0 === e[u].references && (e[u].updater(), e.splice(u, 1))
          }
          i = s
        }
      }
    }, 659: t => {
      var e = {}
      t.exports = function(t, n) {
        var r = function(t) {
          if (void 0 === e[t]) {
            var n = document.querySelector(t)
            if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
              n = n.contentDocument.head
            } catch (t) {
              n = null
            }
            e[t] = n
          }
          return e[t]
        }(t)
        if (!r) throw new Error('Couldn\\'t find a style target. This probably means that the value for the \\'insert\\' parameter is invalid.')
        r.appendChild(n)
      }
    }, 540: t => {
      t.exports = function(t) {
        var e = document.createElement('style')
        return t.setAttributes(e, t.attributes), t.insert(e, t.options), e
      }
    }, 56: (t, e, n) => {
      t.exports = function(t) {
        var e = n.nc
        e && t.setAttribute('nonce', e)
      }
    }, 825: t => {
      t.exports = function(t) {
        if ('undefined' == typeof document) return {
          update: function() {
          }, remove: function() {
          }
        }
        var e = t.insertStyleElement(t)
        return {
          update: function(n) {
            !function(t, e, n) {
              var r = ''
              n.supports && (r += '@supports ('.concat(n.supports, ') {')), n.media && (r += '@media '.concat(n.media, ' {'))
              var o = void 0 !== n.layer
              o && (r += '@layer'.concat(n.layer.length > 0 ? ' '.concat(n.layer) : '', ' {')), r += n.css, o && (r += '}'), n.media && (r += '}'), n.supports && (r += '}')
              var i = n.sourceMap
              i && 'undefined' != typeof btoa && (r += \`\\n/*# sourceMappingURL=data:application/json;base64,\`.concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), ' */')), e.styleTagTransform(r, t, e.options)
            }(e, t, n)
          }, remove: function() {
            !function(t) {
              if (null === t.parentNode) return !1
              t.parentNode.removeChild(t)
            }(e)
          }
        }
      }
    }, 113: t => {
      t.exports = function(t, e) {
        if (e.styleSheet) {
          e.styleSheet.cssText = t
        } else {
          for (; e.firstChild;) e.removeChild(e.firstChild)
          e.appendChild(document.createTextNode(t))
        }
      }
    }
  }, e = {}

  function n(r) {
    var o = e[r]
    if (void 0 !== o) return o.exports
    var i = e[r] = { id: r, exports: {} }
    return t[r](i, i.exports, n), i.exports
  }

  n.n = t => {
    var e = t && t.__esModule ? () => t.default : () => t
    return n.d(e, { a: e }), e
  }, n.d = (t, e) => {
    for (var r in e) n.o(e, r) && !n.o(t, r) && Object.defineProperty(t, r, { enumerable: !0, get: e[r] })
  }, n.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), n.nc = void 0
  const r = { randomUUID: 'undefined' != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto) }
  let o
  const i = new Uint8Array(16)

  function a() {
    if (!o && (o = 'undefined' != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !o)) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported')
    return o(i)
  }

  const c = []
  for (let t = 0; t < 256; ++t) c.push((t + 256).toString(16).slice(1))

  function s(t, e = 0) {
    return c[t[e + 0]] + c[t[e + 1]] + c[t[e + 2]] + c[t[e + 3]] + '-' + c[t[e + 4]] + c[t[e + 5]] + '-' + c[t[e + 6]] + c[t[e + 7]] + '-' + c[t[e + 8]] + c[t[e + 9]] + '-' + c[t[e + 10]] + c[t[e + 11]] + c[t[e + 12]] + c[t[e + 13]] + c[t[e + 14]] + c[t[e + 15]]
  }

  const l = function(t, e, n) {
    if (r.randomUUID && !e && !t) return r.randomUUID()
    const o = (t = t || {}).random || (t.rng || a)()
    if (o[6] = 15 & o[6] | 64, o[8] = 63 & o[8] | 128, e) {
      n = n || 0
      for (let t = 0; t < 16; ++t) e[n + t] = o[t]
      return e
    }
    return s(o)
  }
  var u = n(72), d = n.n(u), f = n(825), h = n.n(f), p = n(659), v = n.n(p), m = n(56), y = n.n(m), g = n(540),
    b = n.n(g), w = n(113), x = n.n(w), k = n(175), L = {}
  L.styleTagTransform = x(), L.setAttributes = y(), L.insert = v().bind(null, 'head'), L.domAPI = h(), L.insertStyleElement = b()
  d()(k.A, L)
  k.A && k.A.locals && k.A.locals

  function E(t) {
    return E = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function(t) {
      return typeof t
    } : function(t) {
      return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? 'symbol' : typeof t
    }, E(t)
  }

  function C() {
    C = function() {
      return e
    }
    var t, e = {}, n = Object.prototype, r = n.hasOwnProperty, o = Object.defineProperty || function(t, e, n) {
        t[e] = n.value
      }, i = 'function' == typeof Symbol ? Symbol : {}, a = i.iterator || '@@iterator',
      c = i.asyncIterator || '@@asyncIterator', s = i.toStringTag || '@@toStringTag'

    function l(t, e, n) {
      return Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }), t[e]
    }

    try {
      l({}, '')
    } catch (t) {
      l = function(t, e, n) {
        return t[e] = n
      }
    }

    function u(t, e, n, r) {
      var i = e && e.prototype instanceof y ? e : y, a = Object.create(i.prototype), c = new T(r || [])
      return o(a, '_invoke', { value: A(t, n, c) }), a
    }

    function d(t, e, n) {
      try {
        return { type: 'normal', arg: t.call(e, n) }
      } catch (t) {
        return { type: 'throw', arg: t }
      }
    }

    e.wrap = u
    var f = 'suspendedStart', h = 'suspendedYield', p = 'executing', v = 'completed', m = {}

    function y() {
    }

    function g() {
    }

    function b() {
    }

    var w = {}
    l(w, a, (function() {
      return this
    }))
    var x = Object.getPrototypeOf, k = x && x(x(_([])))
    k && k !== n && r.call(k, a) && (w = k)
    var L = b.prototype = y.prototype = Object.create(w)

    function S(t) {
      ['next', 'throw', 'return'].forEach((function(e) {
        l(t, e, (function(t) {
          return this._invoke(e, t)
        }))
      }))
    }

    function j(t, e) {
      function n(o, i, a, c) {
        var s = d(t[o], t, i)
        if ('throw' !== s.type) {
          var l = s.arg, u = l.value
          return u && 'object' == E(u) && r.call(u, '__await') ? e.resolve(u.__await).then((function(t) {
            n('next', t, a, c)
          }), (function(t) {
            n('throw', t, a, c)
          })) : e.resolve(u).then((function(t) {
            l.value = t, a(l)
          }), (function(t) {
            return n('throw', t, a, c)
          }))
        }
        c(s.arg)
      }

      var i
      o(this, '_invoke', {
        value: function(t, r) {
          function o() {
            return new e((function(e, o) {
              n(t, r, e, o)
            }))
          }

          return i = i ? i.then(o, o) : o()
        }
      })
    }

    function A(e, n, r) {
      var o = f
      return function(i, a) {
        if (o === p) throw Error('Generator is already running')
        if (o === v) {
          if ('throw' === i) throw a
          return { value: t, done: !0 }
        }
        for (r.method = i, r.arg = a; ;) {
          var c = r.delegate
          if (c) {
            var s = I(c, r)
            if (s) {
              if (s === m) continue
              return s
            }
          }
          if ('next' === r.method) {
            r.sent = r._sent = r.arg
          } else if ('throw' === r.method) {
            if (o === f) throw o = v, r.arg
            r.dispatchException(r.arg)
          } else 'return' === r.method && r.abrupt('return', r.arg)
          o = p
          var l = d(e, n, r)
          if ('normal' === l.type) {
            if (o = r.done ? v : h, l.arg === m) continue
            return { value: l.arg, done: r.done }
          }
          'throw' === l.type && (o = v, r.method = 'throw', r.arg = l.arg)
        }
      }
    }

    function I(e, n) {
      var r = n.method, o = e.iterator[r]
      if (o === t) return n.delegate = null, 'throw' === r && e.iterator.return && (n.method = 'return', n.arg = t, I(e, n), 'throw' === n.method) || 'return' !== r && (n.method = 'throw', n.arg = new TypeError('The iterator does not provide a \\'' + r + '\\' method')), m
      var i = d(o, e.iterator, n.arg)
      if ('throw' === i.type) return n.method = 'throw', n.arg = i.arg, n.delegate = null, m
      var a = i.arg
      return a ? a.done ? (n[e.resultName] = a.value, n.next = e.nextLoc, 'return' !== n.method && (n.method = 'next', n.arg = t), n.delegate = null, m) : a : (n.method = 'throw', n.arg = new TypeError('iterator result is not an object'), n.delegate = null, m)
    }

    function P(t) {
      var e = { tryLoc: t[0] }
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e)
    }

    function Y(t) {
      var e = t.completion || {}
      e.type = 'normal', delete e.arg, t.completion = e
    }

    function T(t) {
      this.tryEntries = [{ tryLoc: 'root' }], t.forEach(P, this), this.reset(!0)
    }

    function _(e) {
      if (e || '' === e) {
        var n = e[a]
        if (n) return n.call(e)
        if ('function' == typeof e.next) return e
        if (!isNaN(e.length)) {
          var o = -1, i = function n() {
            for (; ++o < e.length;) if (r.call(e, o)) return n.value = e[o], n.done = !1, n
            return n.value = t, n.done = !0, n
          }
          return i.next = i
        }
      }
      throw new TypeError(E(e) + ' is not iterable')
    }

    return g.prototype = b, o(L, 'constructor', { value: b, configurable: !0 }), o(b, 'constructor', {
      value: g,
      configurable: !0
    }), g.displayName = l(b, s, 'GeneratorFunction'), e.isGeneratorFunction = function(t) {
      var e = 'function' == typeof t && t.constructor
      return !!e && (e === g || 'GeneratorFunction' === (e.displayName || e.name))
    }, e.mark = function(t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, l(t, s, 'GeneratorFunction')), t.prototype = Object.create(L), t
    }, e.awrap = function(t) {
      return { __await: t }
    }, S(j.prototype), l(j.prototype, c, (function() {
      return this
    })), e.AsyncIterator = j, e.async = function(t, n, r, o, i) {
      void 0 === i && (i = Promise)
      var a = new j(u(t, n, r, o), i)
      return e.isGeneratorFunction(n) ? a : a.next().then((function(t) {
        return t.done ? t.value : a.next()
      }))
    }, S(L), l(L, s, 'Generator'), l(L, a, (function() {
      return this
    })), l(L, 'toString', (function() {
      return '[object Generator]'
    })), e.keys = function(t) {
      var e = Object(t), n = []
      for (var r in e) n.push(r)
      return n.reverse(), function t() {
        for (; n.length;) {
          var r = n.pop()
          if (r in e) return t.value = r, t.done = !1, t
        }
        return t.done = !0, t
      }
    }, e.values = _, T.prototype = {
      constructor: T, reset: function(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = 'next', this.arg = t, this.tryEntries.forEach(Y), !e) for (var n in this) 't' === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t)
      }, stop: function() {
        this.done = !0
        var t = this.tryEntries[0].completion
        if ('throw' === t.type) throw t.arg
        return this.rval
      }, dispatchException: function(e) {
        if (this.done) throw e
        var n = this

        function o(r, o) {
          return c.type = 'throw', c.arg = e, n.next = r, o && (n.method = 'next', n.arg = t), !!o
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var a = this.tryEntries[i], c = a.completion
          if ('root' === a.tryLoc) return o('end')
          if (a.tryLoc <= this.prev) {
            var s = r.call(a, 'catchLoc'), l = r.call(a, 'finallyLoc')
            if (s && l) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0)
              if (this.prev < a.finallyLoc) return o(a.finallyLoc)
            } else if (s) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0)
            } else {
              if (!l) throw Error('try statement without catch or finally')
              if (this.prev < a.finallyLoc) return o(a.finallyLoc)
            }
          }
        }
      }, abrupt: function(t, e) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var o = this.tryEntries[n]
          if (o.tryLoc <= this.prev && r.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
            var i = o
            break
          }
        }
        i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null)
        var a = i ? i.completion : {}
        return a.type = t, a.arg = e, i ? (this.method = 'next', this.next = i.finallyLoc, m) : this.complete(a)
      }, complete: function(t, e) {
        if ('throw' === t.type) throw t.arg
        return 'break' === t.type || 'continue' === t.type ? this.next = t.arg : 'return' === t.type ? (this.rval = this.arg = t.arg, this.method = 'return', this.next = 'end') : 'normal' === t.type && e && (this.next = e), m
      }, finish: function(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e]
          if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), Y(n), m
        }
      }, catch: function(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e]
          if (n.tryLoc === t) {
            var r = n.completion
            if ('throw' === r.type) {
              var o = r.arg
              Y(n)
            }
            return o
          }
        }
        throw Error('illegal catch attempt')
      }, delegateYield: function(e, n, r) {
        return this.delegate = {
          iterator: _(e),
          resultName: n,
          nextLoc: r
        }, 'next' === this.method && (this.arg = t), m
      }
    }, e
  }

  function S(t, e, n, r, o, i, a) {
    try {
      var c = t[i](a), s = c.value
    } catch (t) {
      return void n(t)
    }
    c.done ? e(s) : Promise.resolve(s).then(r, o)
  }

  function j(t) {
    return function() {
      var e = this, n = arguments
      return new Promise((function(r, o) {
        var i = t.apply(e, n)

        function a(t) {
          S(i, r, o, a, c, 'next', t)
        }

        function c(t) {
          S(i, r, o, a, c, 'throw', t)
        }

        a(void 0)
      }))
    }
  }

  var A = 'ZnMtYWRiLWVycg', I = function() {
    var t = j(C().mark((function t() {
      var e, n, r, o, i
      return C().wrap((function(t) {
        for (; ;) switch (t.prev = t.next) {
          case 0:
            if (document.body) {
              t.next = 3
              break
            }
            return t.next = 3, new Promise((function(t) {
              return document.addEventListener('DOMContentLoaded', t)
            }))
          case 3:
            for (e = ['YWQ=', 'YmFubmVyLWFk', 'YmFubmVyX2Fk', 'YmFubmVyLWFkLWNvbnRhaW5lcg==', 'YWQtc2lkZXJhaWw=', 'c3RpY2t5YWRz', 'aW1wcnRudC1jbnQ='], (n = document.createElement('div')).textContent = Math.random().toString(), n.setAttribute(atob('ZGF0YS1mcmVlc3Rhci1hZA=='), Math.random().toString()), r = 0; r < e.length; r++) n.classList.add(atob(e[r]))
            if (n.style.display = 'block', document.body.appendChild(n), o = window.getComputedStyle(n), i = null == o ? void 0 : o.display, n.remove(), 'none' !== i) {
              t.next = 15
              break
            }
            throw new Error(A)
          case 15:
          case'end':
            return t.stop()
        }
      }), t)
    })))
    return function() {
      return t.apply(this, arguments)
    }
  }(), P = function() {
    var t = j(C().mark((function t(e) {
      var n, r = arguments
      return C().wrap((function(t) {
        for (; ;) switch (t.prev = t.next) {
          case 0:
            return n = r.length > 1 && void 0 !== r[1] && r[1], t.abrupt('return', new Promise((function(t, r) {
              var o = document.createElement('script')
              try {
                o.src = e, o.addEventListener('load', (function() {
                  n ? T(e, t, r) : t()
                })), o.addEventListener('error', (function() {
                  r(A)
                })), document.head.appendChild(o)
              } catch (t) {
                r(t)
              } finally {
                o.remove()
              }
            })))
          case 2:
          case'end':
            return t.stop()
        }
      }), t)
    })))
    return function(e) {
      return t.apply(this, arguments)
    }
  }(), Y = function() {
    var t = j(C().mark((function t() {
      var e, n = arguments
      return C().wrap((function(t) {
        for (; ;) switch (t.prev = t.next) {
          case 0:
            return e = n.length > 0 && void 0 !== n[0] ? n[0] : atob('aHR0cHM6Ly9hLnB1Yi5uZXR3b3JrL2NvcmUvaW1ncy8xLnBuZw'), t.abrupt('return', new Promise((function(t, n) {
              var r = encodeURIComponent((new Date).toISOString().split('Z')[0]), o = document.createElement('img')
              o.src = ''.concat(e, '?x=').concat(r), o.onload = j(C().mark((function r() {
                return C().wrap((function(r) {
                  for (; ;) switch (r.prev = r.next) {
                    case 0:
                      return r.next = 2, T(e, t, n)
                    case 2:
                      t(), o.remove()
                    case 4:
                    case'end':
                      return r.stop()
                  }
                }), r)
              }))), o.onerror = function() {
                n(A), o.remove()
              }, document.body.appendChild(o)
            })))
          case 2:
          case'end':
            return t.stop()
        }
      }), t)
    })))
    return function() {
      return t.apply(this, arguments)
    }
  }(), T = function() {
    var t = j(C().mark((function t(e, n, r) {
      var o, i, a, c
      return C().wrap((function(t) {
        for (; ;) switch (t.prev = t.next) {
          case 0:
            return t.prev = 0, t.next = 3, fetch(e)
          case 3:
            o = t.sent, i = null == o ? void 0 : o.redirected, a = null == o ? void 0 : o.url, c = !!a && a !== e, i || c ? r(A) : n(), t.next = 13
            break
          case 10:
            t.prev = 10, t.t0 = t.catch(0), r(A)
          case 13:
          case'end':
            return t.stop()
        }
      }), t, null, [[0, 10]])
    })))
    return function(e, n, r) {
      return t.apply(this, arguments)
    }
  }()

  function _(t) {
    return _ = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function(t) {
      return typeof t
    } : function(t) {
      return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? 'symbol' : typeof t
    }, _(t)
  }

  function z() {
    z = function() {
      return e
    }
    var t, e = {}, n = Object.prototype, r = n.hasOwnProperty, o = Object.defineProperty || function(t, e, n) {
        t[e] = n.value
      }, i = 'function' == typeof Symbol ? Symbol : {}, a = i.iterator || '@@iterator',
      c = i.asyncIterator || '@@asyncIterator', s = i.toStringTag || '@@toStringTag'

    function l(t, e, n) {
      return Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }), t[e]
    }

    try {
      l({}, '')
    } catch (t) {
      l = function(t, e, n) {
        return t[e] = n
      }
    }

    function u(t, e, n, r) {
      var i = e && e.prototype instanceof y ? e : y, a = Object.create(i.prototype), c = new P(r || [])
      return o(a, '_invoke', { value: S(t, n, c) }), a
    }

    function d(t, e, n) {
      try {
        return { type: 'normal', arg: t.call(e, n) }
      } catch (t) {
        return { type: 'throw', arg: t }
      }
    }

    e.wrap = u
    var f = 'suspendedStart', h = 'suspendedYield', p = 'executing', v = 'completed', m = {}

    function y() {
    }

    function g() {
    }

    function b() {
    }

    var w = {}
    l(w, a, (function() {
      return this
    }))
    var x = Object.getPrototypeOf, k = x && x(x(Y([])))
    k && k !== n && r.call(k, a) && (w = k)
    var L = b.prototype = y.prototype = Object.create(w)

    function E(t) {
      ['next', 'throw', 'return'].forEach((function(e) {
        l(t, e, (function(t) {
          return this._invoke(e, t)
        }))
      }))
    }

    function C(t, e) {
      function n(o, i, a, c) {
        var s = d(t[o], t, i)
        if ('throw' !== s.type) {
          var l = s.arg, u = l.value
          return u && 'object' == _(u) && r.call(u, '__await') ? e.resolve(u.__await).then((function(t) {
            n('next', t, a, c)
          }), (function(t) {
            n('throw', t, a, c)
          })) : e.resolve(u).then((function(t) {
            l.value = t, a(l)
          }), (function(t) {
            return n('throw', t, a, c)
          }))
        }
        c(s.arg)
      }

      var i
      o(this, '_invoke', {
        value: function(t, r) {
          function o() {
            return new e((function(e, o) {
              n(t, r, e, o)
            }))
          }

          return i = i ? i.then(o, o) : o()
        }
      })
    }

    function S(e, n, r) {
      var o = f
      return function(i, a) {
        if (o === p) throw Error('Generator is already running')
        if (o === v) {
          if ('throw' === i) throw a
          return { value: t, done: !0 }
        }
        for (r.method = i, r.arg = a; ;) {
          var c = r.delegate
          if (c) {
            var s = j(c, r)
            if (s) {
              if (s === m) continue
              return s
            }
          }
          if ('next' === r.method) {
            r.sent = r._sent = r.arg
          } else if ('throw' === r.method) {
            if (o === f) throw o = v, r.arg
            r.dispatchException(r.arg)
          } else 'return' === r.method && r.abrupt('return', r.arg)
          o = p
          var l = d(e, n, r)
          if ('normal' === l.type) {
            if (o = r.done ? v : h, l.arg === m) continue
            return { value: l.arg, done: r.done }
          }
          'throw' === l.type && (o = v, r.method = 'throw', r.arg = l.arg)
        }
      }
    }

    function j(e, n) {
      var r = n.method, o = e.iterator[r]
      if (o === t) return n.delegate = null, 'throw' === r && e.iterator.return && (n.method = 'return', n.arg = t, j(e, n), 'throw' === n.method) || 'return' !== r && (n.method = 'throw', n.arg = new TypeError('The iterator does not provide a \\'' + r + '\\' method')), m
      var i = d(o, e.iterator, n.arg)
      if ('throw' === i.type) return n.method = 'throw', n.arg = i.arg, n.delegate = null, m
      var a = i.arg
      return a ? a.done ? (n[e.resultName] = a.value, n.next = e.nextLoc, 'return' !== n.method && (n.method = 'next', n.arg = t), n.delegate = null, m) : a : (n.method = 'throw', n.arg = new TypeError('iterator result is not an object'), n.delegate = null, m)
    }

    function A(t) {
      var e = { tryLoc: t[0] }
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e)
    }

    function I(t) {
      var e = t.completion || {}
      e.type = 'normal', delete e.arg, t.completion = e
    }

    function P(t) {
      this.tryEntries = [{ tryLoc: 'root' }], t.forEach(A, this), this.reset(!0)
    }

    function Y(e) {
      if (e || '' === e) {
        var n = e[a]
        if (n) return n.call(e)
        if ('function' == typeof e.next) return e
        if (!isNaN(e.length)) {
          var o = -1, i = function n() {
            for (; ++o < e.length;) if (r.call(e, o)) return n.value = e[o], n.done = !1, n
            return n.value = t, n.done = !0, n
          }
          return i.next = i
        }
      }
      throw new TypeError(_(e) + ' is not iterable')
    }

    return g.prototype = b, o(L, 'constructor', { value: b, configurable: !0 }), o(b, 'constructor', {
      value: g,
      configurable: !0
    }), g.displayName = l(b, s, 'GeneratorFunction'), e.isGeneratorFunction = function(t) {
      var e = 'function' == typeof t && t.constructor
      return !!e && (e === g || 'GeneratorFunction' === (e.displayName || e.name))
    }, e.mark = function(t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, l(t, s, 'GeneratorFunction')), t.prototype = Object.create(L), t
    }, e.awrap = function(t) {
      return { __await: t }
    }, E(C.prototype), l(C.prototype, c, (function() {
      return this
    })), e.AsyncIterator = C, e.async = function(t, n, r, o, i) {
      void 0 === i && (i = Promise)
      var a = new C(u(t, n, r, o), i)
      return e.isGeneratorFunction(n) ? a : a.next().then((function(t) {
        return t.done ? t.value : a.next()
      }))
    }, E(L), l(L, s, 'Generator'), l(L, a, (function() {
      return this
    })), l(L, 'toString', (function() {
      return '[object Generator]'
    })), e.keys = function(t) {
      var e = Object(t), n = []
      for (var r in e) n.push(r)
      return n.reverse(), function t() {
        for (; n.length;) {
          var r = n.pop()
          if (r in e) return t.value = r, t.done = !1, t
        }
        return t.done = !0, t
      }
    }, e.values = Y, P.prototype = {
      constructor: P, reset: function(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = 'next', this.arg = t, this.tryEntries.forEach(I), !e) for (var n in this) 't' === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t)
      }, stop: function() {
        this.done = !0
        var t = this.tryEntries[0].completion
        if ('throw' === t.type) throw t.arg
        return this.rval
      }, dispatchException: function(e) {
        if (this.done) throw e
        var n = this

        function o(r, o) {
          return c.type = 'throw', c.arg = e, n.next = r, o && (n.method = 'next', n.arg = t), !!o
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var a = this.tryEntries[i], c = a.completion
          if ('root' === a.tryLoc) return o('end')
          if (a.tryLoc <= this.prev) {
            var s = r.call(a, 'catchLoc'), l = r.call(a, 'finallyLoc')
            if (s && l) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0)
              if (this.prev < a.finallyLoc) return o(a.finallyLoc)
            } else if (s) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0)
            } else {
              if (!l) throw Error('try statement without catch or finally')
              if (this.prev < a.finallyLoc) return o(a.finallyLoc)
            }
          }
        }
      }, abrupt: function(t, e) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var o = this.tryEntries[n]
          if (o.tryLoc <= this.prev && r.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
            var i = o
            break
          }
        }
        i && ('break' === t || 'continue' === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null)
        var a = i ? i.completion : {}
        return a.type = t, a.arg = e, i ? (this.method = 'next', this.next = i.finallyLoc, m) : this.complete(a)
      }, complete: function(t, e) {
        if ('throw' === t.type) throw t.arg
        return 'break' === t.type || 'continue' === t.type ? this.next = t.arg : 'return' === t.type ? (this.rval = this.arg = t.arg, this.method = 'return', this.next = 'end') : 'normal' === t.type && e && (this.next = e), m
      }, finish: function(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e]
          if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), I(n), m
        }
      }, catch: function(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e]
          if (n.tryLoc === t) {
            var r = n.completion
            if ('throw' === r.type) {
              var o = r.arg
              I(n)
            }
            return o
          }
        }
        throw Error('illegal catch attempt')
      }, delegateYield: function(e, n, r) {
        return this.delegate = {
          iterator: Y(e),
          resultName: n,
          nextLoc: r
        }, 'next' === this.method && (this.arg = t), m
      }
    }, e
  }

  function O(t, e, n, r, o, i, a) {
    try {
      var c = t[i](a), s = c.value
    } catch (t) {
      return void n(t)
    }
    c.done ? e(s) : Promise.resolve(s).then(r, o)
  }

  function H(t) {
    return function() {
      var e = this, n = arguments
      return new Promise((function(r, o) {
        var i = t.apply(e, n)

        function a(t) {
          O(i, r, o, a, c, 'next', t)
        }

        function c(t) {
          O(i, r, o, a, c, 'throw', t)
        }

        a(void 0)
      }))
    }
  }

  function U(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n]
      r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(t, R(r.key), r)
    }
  }

  function R(t) {
    var e = function(t, e) {
      if ('object' != _(t) || !t) return t
      var n = t[Symbol.toPrimitive]
      if (void 0 !== n) {
        var r = n.call(t, e || 'default')
        if ('object' != _(r)) return r
        throw new TypeError('@@toPrimitive must return a primitive value.')
      }
      return ('string' === e ? String : Number)(t)
    }(t, 'string')
    return 'symbol' == _(e) ? e : e + ''
  }

  var F = function() {
    return t = function t(e) {
      !function(t, e) {
        if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function')
      }(this, t), this.config = null, this.langCode = null, this.languages = this.getUserPreferredLanguages(e)
    }, e = [{
      key: 'init', value: (i = H(z().mark((function t() {
        return z().wrap((function(t) {
          for (; ;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this.fetchConfig()
            case 2:
              this.config = t.sent, null !== this.config && (this.langCode = this.getFirstSupportedLanguage(this.languages), this.observe())
            case 4:
            case'end':
              return t.stop()
          }
        }), t, this)
      }))), function() {
        return i.apply(this, arguments)
      })
    }, {
      key: 'fetchConfig', value: (o = H(z().mark((function t() {
        var e, n, r, o, i, a
        return z().wrap((function(t) {
          for (; ;) switch (t.prev = t.next) {
            case 0:
              return n = (e = ['Y29uZmlnLmNvbmZpZy1mYWN0b3J5LmNvbQ==', 'Y29uZmlnLmNvbnRlbnQtc2V0dGluZ3MuY29t', 'Y29uZmlnLnNpdGUtY29uZmlnLmNvbQ==', 'Y29uZmlnLmZyZmlndXJlcy5jb20=']).length - 1, r = Number.isNaN(Number(localStorage.getItem('fs.cdi'))) ? 0 : Number(localStorage.getItem('fs.cdi')), o = Number.isNaN(Number(localStorage.getItem('fs.cfc'))) ? 0 : Number(localStorage.getItem('fs.cfc')), i = atob(e[r]), a = 'https://'.concat(i, '/news12-com.json'), t.prev = 6, t.next = 9, fetch(a)
            case 9:
              return t.abrupt('return', t.sent.json())
            case 12:
              return t.prev = 12, t.t0 = t.catch(6), ++o >= 3 && (o = 0, r++), r > n && (r = 0), t.abrupt('return', null)
            case 18:
              return t.prev = 18, localStorage.setItem('fs.cdi', r), localStorage.setItem('fs.cfc', o), t.finish(18)
            case 22:
            case'end':
              return t.stop()
          }
        }), t, null, [[6, 12, 18, 22]])
      }))), function() {
        return o.apply(this, arguments)
      })
    }, {
      key: 'killScroll', value: function(t) {
        if (t.isScrollDisabled) {
          this.existingOverflow = document.body.style.overflow, document.body.style.overflow = 'hidden'
          var e = window.pageYOffset || document.documentElement.scrollTop,
            n = window.pageXOffset || document.documentElement.scrollLeft
          document.body.style.top = '-'.concat(e, 'px'), document.body.style.left = '-'.concat(n, 'px'), window.onscroll = function() {
            window.scrollTo(n, e)
          }
        }
      }
    }, {
      key: 'reviveScroll', value: function() {
        document.body.style.overflow = this.existingOverflow || '', window.onscroll = function() {
        }
      }
    }, {
      key: 'getUserPreferredLanguages', value: function(t) {
        var e = t.languages, n = t.language, r = void 0 === e ? [n] : e
        if (r) return r.map((function(t) {
          var e = t.trim().toLowerCase()
          if (!e.includes('zh')) return e.split(/-|_/)[0]
          var n = e.split(/-|_/)[1]
          return 'zh' === e || ['hans', 'cn', 'sg'].includes(n) ? 'zh' : ['hant', 'hk', 'mo', 'tw'].includes(n) ? 'zh-hant' : void 0
        }))
      }
    }, {
      key: 'getFirstSupportedLanguage', value: function(t) {
        var e = this, n = ['title', 'paragraphOne', 'buttonText'], r = t.find((function(t) {
          return n.every((function(n) {
            return !!e.config[n][t]
          }))
        }))
        return void 0 !== r ? r : 'en'
      }
    }, {
      key: 'getLocalizedTextContent', value: function(t, e) {
        var n, r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], o = t[e]
        if (void 0 === o) throw new Error('Config text not found for text key '.concat(e))
        return r ? null !== (n = o[this.langCode]) && void 0 !== n ? n : o.en : o[this.langCode]
      }
    }, {
      key: 'getPixelString', value: function(t) {
        return 'number' == typeof t ? ''.concat(t, 'px') : null
      }
    }, {
      key: 'pickContrastingColorValue', value: function(t, e, n) {
        var r = t.substring(1, 7)
        return .299 * parseInt(r.substring(0, 2), 16) + .587 * parseInt(r.substring(2, 4), 16) + .114 * parseInt(r.substring(4, 6), 16) >= 128 ? e : n
      }
    }, {
      key: 'generateOverlay', value: function(t) {
        var e = this, n = t.siteId, r = t.isCloseEnabled, o = t.dismissDuration, i = t.dismissDurationPv, a = t.logoUrl,
          c = t.font, s = t.paragraphTwo, l = t.paragraphThree, u = t.closeText, d = t.linkText, f = t.linkUrl,
          h = t.textColor, p = t.headerTextColor, v = t.buttonTextColor, m = t.headerBgColor, y = t.bgColor,
          g = t.buttonBgColor, b = t.borderColor, w = t.borderWidth, x = t.borderRadius, k = t.closeButtonColor,
          L = t.closeTextColor, E = t.linkTextColor, C = t.linkTextDecoration, S = t.linkVisitedTextColor,
          j = t.hasFsBranding, A = t.disableInstructions, I = document.createElement('div')
        I.style.setProperty('--_1j43n1n', g || '#40C28A'), I.style.setProperty('--_13jktuh', v || '#000000'), I.style.setProperty('--_1szoe3t', this.pickContrastingColorValue(y || '#FFFFFF', 'white', 'black')), E && I.style.setProperty('--zl2fp4', E), S && I.style.setProperty('--_1o7vm1f', S), C && I.style.setProperty('--_1ogdq5f', C), I.classList.add('_1mbd8ky'), I.id = 'eavgqh', I.dir = 'auto', this.oid = I.id
        var P = document.createElement('div')
        P.classList.add('_198yzhg'), y && (P.style.backgroundColor = y), c && (P.style.fontFamily = c), h && (P.style.color = h)
        var Y = this.getPixelString(x), T = this.getPixelString(w)
        Y && (P.style.borderRadius = Y), (b || T) && (P.style.borderStyle = 'solid'), b && (P.style.borderColor = b), T && (P.style.borderWidth = T)
        var _ = document.createElement('header')
        if (p && (_.style.color = p), m) {
          _.style.backgroundColor = m
          var z = Y || '1em'
          _.style.borderTopLeftRadius = z, _.style.borderTopRightRadius = z
        }
        if (a) {
          var O = document.createElement('img')
          O.src = a, O.alt = 'Logo', O.onerror = function() {
            this.style.display = 'none'
          }, _.appendChild(O)
        }
        var H = document.createElement('h2')
        H.textContent = this.getLocalizedTextContent(t, 'title'), _.appendChild(H)
        var U = document.createElement('section')
        U.classList.add('ijl1ch')
        var R = document.createElement('p')
        if (R.textContent = this.getLocalizedTextContent(t, 'paragraphOne'), U.appendChild(R), s && 0 !== Object.keys(s).length) {
          var F = document.createElement('p')
          F.textContent = this.getLocalizedTextContent(t, 'paragraphTwo'), U.appendChild(F)
        }
        if (l && 0 !== Object.keys(l).length) {
          var B = document.createElement('p')
          B.textContent = this.getLocalizedTextContent(t, 'paragraphThree'), U.appendChild(B)
        }
        var V = d && this.getLocalizedTextContent(t, 'linkText'),
          N = f && this.getLocalizedTextContent(t, 'linkUrl', !0)
        if (V && N) {
          var G = document.createElement('div')
          G.style.margin = '0 0 1em'
          var Q = document.createElement('a')
          Q.classList.add('nb9oy2'), E && Q.classList.add('zl2fp4'), S && Q.classList.add('_1o7vm1f'), C && Q.classList.add('_1ogdq5f'), Q.textContent = V, Q.href = N, Q.target = '_blank', G.appendChild(Q), U.appendChild(G)
        }
        var D = document.createElement('button')
        if (D.classList.add('_12a8rkv'), D.tabIndex = 0, D.textContent = this.getLocalizedTextContent(t, 'buttonText'), g && (D.style.backgroundColor = g), v && (D.style.color = v), D.onclick = function() {
          document.querySelector('section.ijl1ch').classList.add('v1fx5m'), document.querySelector('section._1863sjh').classList.remove('v1fx5m')
        }, U.appendChild(D), r) {
          var M = function() {
            I.remove(), e.reviveScroll(), o || i ? (sessionStorage.removeItem('fs.adb'.concat(n || '', '.dis')), i ? e.updateValues('p') : o && e.updateValues('dt')) : sessionStorage.setItem('fs.adb'.concat(n || '', '.dis'), '1')
          }, W = document.createElement('span')
          if (W.classList.add('ggmtgz'), W.innerHTML = '&times;', W.tabIndex = 0, k && (W.style.color = k), W.addEventListener('click', M), _.appendChild(W), u && 0 !== Object.keys(u).length) {
            var J = document.createElement('div')
            J.classList.add('axogvc')
            var Z = document.createElement('p')
            Z.classList.add('_19ax4ey'), Z.textContent = this.getLocalizedTextContent(t, 'closeText'), L && (Z.style.color = L), Z.addEventListener('click', M), J.appendChild(Z), U.appendChild(J)
          }
        }
        var q = document.createElement('section')
        q.classList.add('_1863sjh', 'v1fx5m')
        var X = document.createElement('h4')
        X.classList.add('_1uwwg2n'), X.textContent = this.getLocalizedTextContent(t, 'instructionsTitle')
        var K = document.createElement('div')
        K.classList.add('_1w7m8bp')
        var $ = document.createElement('ul')
        $.classList.add('hyxf2p')
        var tt = document.createElement('div')
        tt.classList.add('rrdw3j'), A.forEach((function(t, n) {
          var r = document.createElement('li')
          r.onclick = function() {
            return function(t) {
              for (var e = document.querySelectorAll('.hyxf2p > li'), n = document.getElementsByClassName('aty11x'), r = 0; r < n.length; r++) e[r].classList.remove('vm0jvi'), n[r].classList.remove('vm0jvi')
              e[t].classList.add('vm0jvi'), n[t].classList.add('vm0jvi')
            }(n)
          }, r.textContent = e.getLocalizedTextContent(t, 'name', !0), $.appendChild(r)
          var o = document.createElement('ol')
          o.classList.add('aty11x'), 0 === n && (r.classList.add('vm0jvi'), o.classList.add('vm0jvi')), e.getLocalizedTextContent(t, 'steps').forEach((function(t) {
            var e = document.createElement('li')
            e.textContent = t, o.appendChild(e)
          })), tt.appendChild(o)
        }))
        var et = this.getLocalizedTextContent(t, 'disclaimerText'), nt = document.createElement('p')
        nt.textContent = et, tt.appendChild(nt), K.appendChild($), K.appendChild(tt)
        var rt = document.createElement('button')
        if (rt.classList.add('_12a8rkv', '_1ungsbp'), rt.textContent = this.getLocalizedTextContent(t, 'backButtonText'), g && (rt.style.backgroundColor = g), v && (rt.style.color = v), rt.onclick = function() {
          document.querySelector('section._1863sjh').classList.add('v1fx5m'), document.querySelector('section.ijl1ch').classList.remove('v1fx5m')
        }, q.appendChild(X), q.appendChild(K), q.appendChild(rt), P.appendChild(_), P.appendChild(U), P.appendChild(q), j) {
          var ot = document.createElement('a')
          ot.classList.add('_1ad7ks0'), ot.href = atob('aHR0cHM6Ly9mcmVlc3Rhci5jb20vYWQtcHJvZHVjdHMvZGVza3RvcC1tb2JpbGUvZnJlZXN0YXItcmVjb3ZlcmVk'), ot.target = '_blank'
          var it = document.createElement('img')
          it.alt = 'Logo', it.src = this.pickContrastingColorValue(y || '#FFFFFF', 'data:image/png;base64,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', 'data:image/png;base64,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'), ot.appendChild(it), P.appendChild(ot)
        }
        return I.appendChild(P), I
      }
    }, {
      key: 'getAndSetOverlay', value: (r = H(z().mark((function t(e) {
        var n, r, o, i
        return z().wrap((function(t) {
          for (; ;) switch (t.prev = t.next) {
            case 0:
              if (this.post(!0, e), e.dismissDuration || e.dismissDurationPv || '1' !== sessionStorage.getItem('fs.adb'.concat(e.siteId || '', '.dis'))) {
                t.next = 3
                break
              }
              return t.abrupt('return')
            case 3:
              if (n = localStorage.getItem('fs.adb'), r = n && JSON.parse(n), !e.dismissDurationPv || !r.p || 'number' != typeof r.p) {
                t.next = 14
                break
              }
              if (!(e.dismissDurationPv <= r.p + 1)) {
                t.next = 10
                break
              }
              this.clearValue('p'), t.next = 12
              break
            case 10:
              return this.updateValues('p'), t.abrupt('return')
            case 12:
              t.next = 15
              break
            case 14:
              this.clearValue('p')
            case 15:
              if (o = parseInt(r.dt, 10), !e.dismissDuration || !o) {
                t.next = 25
                break
              }
              if (!(Math.abs((Date.now() - o) / 36e5) < e.dismissDuration)) {
                t.next = 22
                break
              }
              return t.abrupt('return')
            case 22:
              this.clearValue('dt')
            case 23:
              t.next = 26
              break
            case 25:
              this.clearValue('dt')
            case 26:
              if (document.body) {
                t.next = 29
                break
              }
              return t.next = 29, new Promise((function(t) {
                return document.addEventListener('DOMContentLoaded', t)
              }))
            case 29:
              if (this.killScroll(e), null === document.querySelector('#'.concat(this.oid))) {
                t.next = 32
                break
              }
              return t.abrupt('return')
            case 32:
              i = this.generateOverlay(e), document.body.appendChild(i)
            case 34:
            case'end':
              return t.stop()
          }
        }), t, this)
      }))), function(t) {
        return r.apply(this, arguments)
      })
    }, {
      key: 'getStatus', value: function(t, e) {
        return !0 === e ? 1 : 2 === t || 1 === t ? 2 : 0
      }
    }, {
      key: 'getAndSetData', value: function(t) {
        var e, n, r, o = localStorage.getItem('fs.adb'), i = o && JSON.parse(o), a = Date.now()
        return i ? (e = i.i, n = i.ot, r = this.getStatus(i.s, t)) : (i = {}, e = l(), n = a, r = t ? 1 : 0), i.i = e, i.s = r, i.ot = n, i.lt = a, localStorage.setItem('fs.adb', JSON.stringify(i)), i
      }
    }, {
      key: 'updateValues', value: function(t) {
        var e = localStorage.getItem('fs.adb'), n = e && JSON.parse(e)
        'p' === t ? (n.p = n.p ? n.p + 1 : 1, n.dt && delete n.dt) : 'dt' === t && (n.dt = Date.now(), n.p && delete n.p), localStorage.setItem('fs.adb', JSON.stringify(n))
      }
    }, {
      key: 'clearValue', value: function(t) {
        var e = localStorage.getItem('fs.adb'), n = e && JSON.parse(e)
        n[t] && (delete n[t], localStorage.setItem('fs.adb', JSON.stringify(n)))
      }
    }, {
      key: 'post', value: function(t, e) {
        var n = atob('c2l0ZS1jb25maWcuY29t'), r = e.cDomain || n, o = 'https://'.concat(r, '/v2/abr'),
          i = this.getAndSetData(t), a = e.accountId, c = e.siteId,
          s = navigator.userAgent || window.navigator.userAgent, l = document.referrer, u = window.location, d = {
            accountId: a, siteId: c, userId: i.i, url: u.href, referalURL: l, userAgent: s, status: function(t) {
              switch (t) {
                case 0:
                  return 'not detected'
                case 1:
                  return 'detected'
                case 2:
                  return 'recovered'
                default:
                  return
              }
            }(i.s), returning: i.ot !== i.lt, version: '1.4.0'
          }
        fetch(o, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Client-Geo-Location': '{client_region},{client_region_subdivision},{client_city}'
          },
          body: JSON.stringify(d)
        }).catch((function() {
        }))
      }
    }, {
      key: 'observe', value: function() {
        var t = this, e = ''
        new MutationObserver((function() {
          location.pathname !== e && (e = location.pathname, t.run())
        })).observe(document, { subtree: !0, childList: !0 })
      }
    }, {
      key: 'run', value: function() {
        var t = this, e = this.config
        setTimeout(H(z().mark((function n() {
          return z().wrap((function(n) {
            for (; ;) switch (n.prev = n.next) {
              case 0:
                return n.prev = 0, n.next = 3, I()
              case 3:
                return n.next = 5, Y()
              case 5:
                return n.next = 7, P(atob('aHR0cHM6Ly9hLnB1Yi5uZXR3b3JrL2NvcmUvcHJlYmlkLXVuaXZlcnNhbC1jcmVhdGl2ZS5qcw=='), !0)
              case 7:
                return n.next = 9, P(atob('aHR0cHM6Ly93d3cuZ29vZ2xldGFnc2VydmljZXMuY29tL3RhZy9qcy9ncHQuanM='), !1)
              case 9:
                t.post(!1, e), n.next = 17
                break
              case 12:
                if (n.prev = 12, n.t0 = n.catch(0), n.t0 !== A && (null === n.t0 || void 0 === n.t0 ? void 0 : n.t0.message) !== A) {
                  n.next = 17
                  break
                }
                return n.next = 17, t.getAndSetOverlay(e)
              case 17:
              case'end':
                return n.stop()
            }
          }), n, null, [[0, 12]])
        }))), 500)
      }
    }], e && U(t.prototype, e), n && U(t, n), Object.defineProperty(t, 'prototype', { writable: !1 }), t
    var t, e, n, r, o, i
  }()

  function B(t) {
    return B = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function(t) {
      return typeof t
    } : function(t) {
      return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? 'symbol' : typeof t
    }, B(t)
  }

  function V(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n]
      r.enumerable = r.enumerable || !1, r.configurable = !0, 'value' in r && (r.writable = !0), Object.defineProperty(t, N(r.key), r)
    }
  }

  function N(t) {
    var e = function(t, e) {
      if ('object' != B(t) || !t) return t
      var n = t[Symbol.toPrimitive]
      if (void 0 !== n) {
        var r = n.call(t, e || 'default')
        if ('object' != B(r)) return r
        throw new TypeError('@@toPrimitive must return a primitive value.')
      }
      return ('string' === e ? String : Number)(t)
    }(t, 'string')
    return 'symbol' == B(e) ? e : e + ''
  }

  var G = ['googlebot', 'mediapartners-google', 'adsbot-google', 'bingbot', 'slurp', 'duckduckbot', 'baiduspider', 'yandexbot', 'konqueror/3.5', 'Exabot/3.0', 'facebot', 'facebookexternalhit/1.0', 'facebookexternalhit/1.1', 'ia_archiver']
  new (function() {
    return t = function t(e) {
      !function(t, e) {
        if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function')
      }(this, t), this.globalNavigator = e
    }, (e = [{
      key: 'checkForBot', value: function() {
        var t = this.globalNavigator.userAgent
        t && G.forEach((function(e) {
          if (RegExp(e.toLowerCase()).test(t.toLowerCase())) throw new Error('bot detected')
        }))
      }
    }]) && V(t.prototype, e), n && V(t, n), Object.defineProperty(t, 'prototype', { writable: !1 }), t
    var t, e, n
  }())(window.navigator).checkForBot(), new F(window.navigator).init()
})()
`

// export const CCPA = `
// (function() {
//   var e = false
//   var c = window
//   var t = document
//
//   function r() {
//     if (!c.frames['__uspapiLocator']) {
//       if (t.body) {
//         var a = t.body
//         var e = t.createElement('iframe')
//         e.style.cssText = 'display:none'
//         e.name = '__uspapiLocator'
//         a.appendChild(e)
//       } else {
//         setTimeout(r, 5)
//       }
//     }
//   }
//
//   r()
//
//   function p() {
//     var a = arguments
//     __uspapi.a = __uspapi.a || []
//     if (!a.length) {
//       return __uspapi.a
//     } else if (a[0] === 'ping') {
//       a[2]({ gdprAppliesGlobally: e, cmpLoaded: false }, true)
//     } else {
//       __uspapi.a.push([].slice.apply(a))
//     }
//   }
//
//   function l(t) {
//     var r = typeof t.data === 'string'
//     try {
//       var a = r ? JSON.parse(t.data) : t.data
//       if (a.__cmpCall) {
//         var n = a.__cmpCall
//         c.__uspapi(n.command, n.parameter, function(a, e) {
//           var c = { __cmpReturn: { returnValue: a, success: e, callId: n.callId } }
//           t.source.postMessage(r ? JSON.stringify(c) : c, '*')
//         })
//       }
//     } catch (a) {
//     }
//   }
//
//   if (typeof __uspapi !== 'function') {
//     c.__uspapi = p
//     __uspapi.msgHandler = l
//     c.addEventListener('message', l, false)
//   }
// })()
// `
//
// export const CMP_config = `
// window._sp_queue = []
// window._sp_ = {
//   config: {
//     accountId: 1638,
//     propertyHref: 'https://news12.com',
//     baseEndpoint: 'https://cdn.privacy-mgmt.com',
//     usnat: {
//       includeUspApi: true
//     },
//
//     gdpr: {},
//     events: {
//       onMessageChoiceSelect: function() {
//         console.log('[event] onMessageChoiceSelect', arguments)
//       },
//       onMessageReady: function() {
//         console.log('[event] onMessageReady', arguments)
//       },
//       onMessageChoiceError: function() {
//         console.log('[event] onMessageChoiceError', arguments)
//       },
//       onPrivacyManagerAction: function() {
//         console.log('[event] onPrivacyManagerAction', arguments)
//       },
//       onPMCancel: function() {
//         console.log('[event] onPMCancel', arguments)
//       },
//       onMessageReceiveData: function() {
//         console.log('[event] onMessageReceiveData', arguments)
//       },
//       onSPPMObjectReady: function() {
//         console.log('[event] onSPPMObjectReady', arguments)
//       },
//
//       /* Function required for resurfacing links */
//       onConsentReady: function(message_type, uuid, string, info) {
//         if (message_type == 'usnat' && info.applies) {
//           /* code to insert the GPP footer link */
//           document.getElementById('pmLink').style.visibility = 'visible'
//           document.getElementById('pmLink').innerHTML =
//             'Do Not Sell or Share My Personal Information'
//           document.getElementById('pmLink').onclick = function() {
//             /* Set GPP ID */
//             window._sp_.usnat.loadPrivacyManagerModal('1318304')
//           }
//         }
//         if (message_type == 'gdpr' && info.applies) {
//           /* code to insert the GDPR footer link */
//           document.getElementById('pmLink').style.visibility = 'visible'
//           document.getElementById('pmLink').innerHTML =
//             'Privacy Preferences'
//           document.getElementById('pmLink').onclick = function() {
//             /* Set GDPR ID */
//             window._sp_.gdpr.loadPrivacyManagerModal('1319621')
//           }
//         }
//       },
//       onError: function() {
//         console.log('[event] onError', arguments)
//       }
//     }
//   }
// }
// function loadCMP() {
//   var spScript = document.createElement('script');
//   spScript.src = 'https://cdn.privacy-mgmt.com/unified/wrapperMessagingWithoutDetection.js';
//   spScript.async = true;
//   document.head.appendChild(spScript);
// }
// loadCMP();
// `
//
// export const GDPR = `
// 'use strict'
//
// function _typeof(t) {
//   return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function(t) {
//     return typeof t
//   } : function(t) {
//     return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? 'symbol' : typeof t
//   })(t)
// }
//
// !function() {
//   var t = function() {
//     var t, e, o = [], n = window, r = n
//     for (; r;) {
//       try {
//         if (r.frames.__tcfapiLocator) {
//           t = r
//           break
//         }
//       } catch (t) {
//       }
//       if (r === n.top) break
//       r = r.parent
//     }
//     t || (!function t() {
//       var e = n.document, o = !!n.frames.__tcfapiLocator
//       if (!o) if (e.body) {
//         var r = e.createElement('iframe')
//         r.style.cssText = 'display:none', r.name = '__tcfapiLocator', e.body.appendChild(r)
//       } else setTimeout(t, 5)
//       return !o
//     }(), n.__tcfapi = function() {
//       for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r]
//       if (!n.length) return o
//       'setGdprApplies' === n[0] ? n.length > 3 && 2 === parseInt(n[1], 10) && 'boolean' == typeof n[3] && (e = n[3], 'function' == typeof n[2] && n[2]('set', !0)) : 'ping' === n[0] ? 'function' == typeof n[2] && n[2]({
//         gdprApplies: e,
//         cmpLoaded: !1,
//         cmpStatus: 'stub'
//       }) : o.push(n)
//     }, n.addEventListener('message', (function(t) {
//       var e = 'string' == typeof t.data, o = {}
//       if (e) try {
//         o = JSON.parse(t.data)
//       } catch (t) {
//       } else o = t.data
//       var n = 'object' === _typeof(o) && null !== o ? o.__tcfapiCall : null
//       n && window.__tcfapi(n.command, n.version, (function(o, r) {
//         var a = { __tcfapiReturn: { returnValue: o, success: r, callId: n.callId } }
//         t && t.source && t.source.postMessage && t.source.postMessage(e ? JSON.stringify(a) : a, '*')
//       }), n.parameter)
//     }), !1))
//   }
//   'undefined' != typeof module ? module.exports = t : t()
// }()
// `
//
// export const GPP = `
// window.__gpp_addFrame = function(e) {
//   if (!window.frames[e]) if (document.body) {
//     var t = document.createElement('iframe')
//     t.style.cssText = 'display:none', t.name = e, document.body.appendChild(t)
//   } else window.setTimeout(window.__gpp_addFrame, 10, e)
// }, window.__gpp_stub = function() {
//   var e = arguments
//   if (__gpp.queue = __gpp.queue || [], __gpp.events = __gpp.events || [], !e.length || 1 == e.length && 'queue' == e[0]) return __gpp.queue
//   if (1 == e.length && 'events' == e[0]) return __gpp.events
//   var t = e[0], p = e.length > 1 ? e[1] : null, s = e.length > 2 ? e[2] : null
//   if ('ping' === t) {
//     p({
//       gppVersion: '1.1',
//       cmpStatus: 'stub',
//       cmpDisplayStatus: 'hidden',
//       signalStatus: 'not ready',
//       supportedAPIs: ['2:tcfeuv2', '5:tcfcav1', '6:uspv1', '7:usnat', '8:usca', '9:usva', '10:usco', '11:usut', '12:usct'],
//       cmpId: 0,
//       sectionList: [],
//       applicableSections: [],
//       gppString: '',
//       parsedSections: {}
//     }, !0)
//   } else if ('addEventListener' === t) {
//     'lastId' in __gpp || (__gpp.lastId = 0), __gpp.lastId++
//     var n = __gpp.lastId
//     __gpp.events.push({ id: n, callback: p, parameter: s }), p({
//       eventName: 'listenerRegistered',
//       listenerId: n,
//       data: !0,
//       pingData: {
//         gppVersion: '1.1',
//         cmpStatus: 'stub',
//         cmpDisplayStatus: 'hidden',
//         signalStatus: 'not ready',
//         supportedAPIs: ['2:tcfeuv2', '5:tcfcav1', '6:uspv1', '7:usnat', '8:usca', '9:usva', '10:usco', '11:usut', '12:usct'],
//         cmpId: 0,
//         sectionList: [],
//         applicableSections: [],
//         gppString: '',
//         parsedSections: {}
//       }
//     }, !0)
//   } else if ('removeEventListener' === t) {
//     for (var a = !1, i = 0; i < __gpp.events.length; i++) if (__gpp.events[i].id == s) {
//       __gpp.events.splice(i, 1), a = !0
//       break
//     }
//     p({
//       eventName: 'listenerRemoved',
//       listenerId: s,
//       data: a,
//       pingData: {
//         gppVersion: '1.1',
//         cmpStatus: 'stub',
//         cmpDisplayStatus: 'hidden',
//         signalStatus: 'not ready',
//         supportedAPIs: ['2:tcfeuv2', '5:tcfcav1', '6:uspv1', '7:usnat', '8:usca', '9:usva', '10:usco', '11:usut', '12:usct'],
//         cmpId: 0,
//         sectionList: [],
//         applicableSections: [],
//         gppString: '',
//         parsedSections: {}
//       }
//     }, !0)
//   } else 'hasSection' === t ? p(!1, !0) : 'getSection' === t || 'getField' === t ? p(null, !0) : __gpp.queue.push([].slice.apply(e))
// }, window.__gpp_msghandler = function(e) {
//   var t = 'string' == typeof e.data
//   try {
//     var p = t ? JSON.parse(e.data) : e.data
//   } catch (e) {
//     p = null
//   }
//   if ('object' == typeof p && null !== p && '__gppCall' in p) {
//     var s = p.__gppCall
//     window.__gpp(s.command, (function(p, n) {
//       var a = { __gppReturn: { returnValue: p, success: n, callId: s.callId } }
//       e.source.postMessage(t ? JSON.stringify(a) : a, '*')
//     }), 'parameter' in s ? s.parameter : null, 'version' in s ? s.version : '1.1')
//   }
// }, '__gpp' in window && 'function' == typeof window.__gpp || (window.__gpp = window.__gpp_stub, window.addEventListener('message', window.__gpp_msghandler, !1), window.__gpp_addFrame('__gppLocator'))
// `
